export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/ziying-858970e281d7e01e0e6a17a8068b1682.png";